/* JSQ physical gift card custom amount picker | Aug 12, 2026 */
(function(){
'use strict';
var picker=document.querySelector('[data-gift-card-picker]');
if(!picker||picker.dataset.gcInitialized==='true')return;
picker.dataset.gcInitialized='true';

var root=picker.closest('.mp-page');
var form=root&&root.querySelector('#mp-product-form');
if(!root||!form)return;

var amountData=[];
var dataEl=picker.querySelector('[data-gc-amounts]');
try{amountData=JSON.parse((dataEl&&dataEl.textContent)||'[]');}catch(error){amountData=[];}

var amountMap={};
amountData.forEach(function(item){
  var amount=Number(item.amount);
  if(Number.isInteger(amount)&&item.id)amountMap[amount]=item;
});

var minAmount=parseInt(picker.getAttribute('data-min-amount'),10)||1;
var maxAmount=parseInt(picker.getAttribute('data-max-amount'),10)||1000;
var customInput=picker.querySelector('[data-gc-custom]');
var currentEl=picker.querySelector('[data-gc-current]');
var statusEl=picker.querySelector('[data-gc-status]');
var presets=[].slice.call(picker.querySelectorAll('[data-gc-preset]'));
var idInput=form.querySelector('[data-mp-variant-id]');
var atc=form.querySelector('.mp-atc');
var sticky=root.querySelector('[data-mp-sticky-atc]');
var priceEl=root.querySelector('[data-mp-price]');
var pricePrefix=root.querySelector('[data-mp-price-prefix]');
var compareEl=root.querySelector('[data-mp-compare]');
var saveEl=root.querySelector('[data-mp-save]');
var stockEl=root.querySelector('[data-mp-stockline]');
var summaryEl=root.querySelector('[data-mp-selection-summary]');
var summaryLiveEl=root.querySelector('[data-mp-selection-live]');
var skuEl=root.querySelector('[data-mp-sku]');
var detailSkuEl=root.querySelector('[data-mp-detail-sku]');
var detailAvailabilityEl=root.querySelector('[data-mp-detail-availability]');
var dyn=root.querySelector('.mp-dynamic-checkout');
var qty=form.querySelector('[data-mp-qty-input]');
var currency=root.getAttribute('data-currency')||'USD';
var chooseText=picker.dataset.gcChoose||'Choose an available gift card amount.';
var availableText=picker.dataset.gcAvailable||'Available amounts';
var selected=null;
var submitting=false;

function money(cents){
  var value=Number(cents||0)/100;
  try{return new Intl.NumberFormat(undefined,{style:'currency',currency:currency}).format(value);}
  catch(error){return '$'+value.toFixed(2);}
}

function setButton(button,enabled,label){
  if(!button)return;
  button.disabled=!enabled;
  button.setAttribute('aria-disabled',enabled?'false':'true');
  button.setAttribute('data-mp-state',enabled?'available':'incomplete');
  var span=button.querySelector('span');
  if(span)span.textContent=label;else button.textContent=label;
}

function setStatus(message,kind){
  if(!statusEl)return;
  statusEl.textContent=message;
  statusEl.classList.toggle('is-valid',kind==='valid');
  statusEl.classList.toggle('is-error',kind==='error');
}

function updatePresetState(amount){
  presets.forEach(function(button){
    var active=Number(button.getAttribute('data-gc-preset'))===Number(amount);
    button.classList.toggle('is-active',active);
    button.setAttribute('aria-checked',active?'true':'false');
  });
}

function updateKeyFact(){
  root.querySelectorAll('.mp-key-facts>div').forEach(function(card){
    var term=card.querySelector('dt');
    var detail=card.querySelector('dd');
    if(!term||!detail)return;
    if(term.textContent.trim().toLowerCase()==='choose'){
      term.textContent='Amount';
      detail.textContent=availableText;
    }
  });
}

function renderEmpty(message,kind){
  selected=null;
  delete picker.dataset.gcVariantId;
  if(idInput){idInput.value='';idInput.disabled=true;}
  if(currentEl){currentEl.textContent='Required';currentEl.classList.add('is-required');}
  updatePresetState(null);
  setStatus(message||chooseText,kind||'');
  if(pricePrefix)pricePrefix.hidden=true;
  if(priceEl)priceEl.textContent='Choose amount';
  if(compareEl)compareEl.hidden=true;
  if(saveEl)saveEl.hidden=true;
  if(stockEl)stockEl.innerHTML='<span class="mp-stock mp-stock--choose">Choose an amount</span><span class="mp-ship">The exact amount will be charged at checkout</span>';
  if(summaryEl){summaryEl.textContent=chooseText;summaryEl.classList.add('is-incomplete');}
  if(summaryLiveEl)summaryLiveEl.textContent='Choose a gift card amount.';
  if(skuEl)skuEl.textContent='Select amount';
  if(detailSkuEl)detailSkuEl.textContent='Select amount';
  if(detailAvailabilityEl)detailAvailabilityEl.textContent='Choose amount';
  setButton(atc,false,'Choose amount first');
  setButton(sticky,false,'Choose amount');
  if(dyn){dyn.hidden=true;dyn.style.display='none';}
  root.dataset.mpSelectionReady='false';
  root.classList.add('needs-selection');
  form.dispatchEvent(new CustomEvent('jsq:gc-quantity',{detail:{variant:selected}}));
}

function renderSelected(){
  if(!selected){renderEmpty();return;}
  if(root.getAttribute('data-mp-purchase-blocked')==='true'){renderEmpty(root.dataset.mpBlockedButton||'Options under review','error');return;}
  picker.dataset.gcVariantId=String(selected.id);
  var amount=Number(selected.amount);
  var label=money(selected.price);
  if(idInput){idInput.value=String(selected.id);idInput.disabled=false;}
  if(currentEl){currentEl.textContent='$'+amount;currentEl.classList.remove('is-required');}
  updatePresetState(amount);
  setStatus('Physical gift card amount: '+label+'.','valid');
  if(pricePrefix)pricePrefix.hidden=true;
  if(priceEl)priceEl.textContent=label;
  if(compareEl)compareEl.hidden=true;
  if(saveEl)saveEl.hidden=true;
  if(stockEl)stockEl.innerHTML='<span class="mp-stock">'+(selected.available?'Available':'Sold out')+'</span><span class="mp-ship">Physical gift card prepared by Judaica Square</span>';
  if(summaryEl){summaryEl.textContent='Gift card amount: '+label;summaryEl.classList.remove('is-incomplete');}
  if(summaryLiveEl)summaryLiveEl.textContent='Gift card amount selected: '+label+'.';
  if(skuEl)skuEl.textContent=selected.sku||'Physical gift card';
  if(detailSkuEl)detailSkuEl.textContent=selected.sku||'Physical gift card';
  if(detailAvailabilityEl)detailAvailabilityEl.textContent=selected.available?'Available':'Sold out';
  setButton(atc,!!selected.available,selected.available?'Add to cart · '+label:'Sold out');
  setButton(sticky,!!selected.available,selected.available?'Add to cart · '+label:'Sold out');
  if(dyn){dyn.hidden=true;dyn.style.display='none';}
  root.dataset.mpSelectionReady='true';
  root.classList.remove('needs-selection','is-invalid-combination','is-purchase-blocked');
  form.dispatchEvent(new CustomEvent('jsq:gc-quantity',{detail:{variant:selected}}));
}

function chooseAmount(value,source){
  var amount=Number(value);
  if(value===''||value===null){renderEmpty();return;}
  if(!Number.isInteger(amount)||amount<minAmount||amount>maxAmount){
    renderEmpty('Enter a whole-dollar amount from $'+minAmount+' to $'+maxAmount+'.','error');
    return;
  }
  var variant=amountMap[amount];
  if(!variant){
    renderEmpty('That amount is not available yet. Please choose another amount.','error');
    return;
  }
  selected=variant;
  if(source==='preset'&&customInput)customInput.value='';
  renderSelected();
}

presets.forEach(function(button){
  button.addEventListener('click',function(event){
    event.preventDefault();
    chooseAmount(button.getAttribute('data-gc-preset'),'preset');
  });
});

if(customInput){
  customInput.addEventListener('input',function(){chooseAmount(customInput.value,'custom');});
  customInput.addEventListener('blur',function(){
    if(customInput.value&&selected)customInput.value=String(selected.amount);
  });
}

function collectProperties(){
  var properties={};
  form.querySelectorAll('[name^="properties["]').forEach(function(field){
    if(field.disabled)return;
    if((field.type==='checkbox'||field.type==='radio')&&!field.checked)return;
    var match=field.name.match(/^properties\[(.*)\]$/);
    if(match&&field.value)properties[match[1]]=field.value;
  });
  return properties;
}

function showSubmitError(message){
  submitting=false;
  delete form.dataset.jsqPurchasePending;
  if(selected)renderSelected();
  setStatus(message||'We could not add the gift card. Please try again.','error');
}

function addSelectedToCart(){
  if(!selected||!selected.available||root.getAttribute('data-mp-purchase-blocked')==='true'){
    renderEmpty('Choose a valid gift card amount before continuing.','error');
    if(customInput)customInput.focus();
    return;
  }
  if(submitting)return;
  form.dispatchEvent(new CustomEvent('jsq:gc-quantity',{detail:{variant:selected}}));
  var quantity=Number(qty&&qty.value);
  if(!Number.isSafeInteger(quantity)||quantity<1||!qty||!qty.checkValidity()){
    if(qty){qty.focus();qty.reportValidity();}
    return;
  }
  submitting=true;
  form.dataset.jsqPurchasePending='true';
  form.dispatchEvent(new CustomEvent('jsq:gc-quantity',{detail:{variant:selected}}));
  var mainItem={id:Number(selected.id),quantity:quantity};
  var properties=collectProperties();
  if(Object.keys(properties).length)mainItem.properties=properties;
  var sellingPlan=form.querySelector('[name="selling_plan"]');
  if(sellingPlan&&sellingPlan.value)mainItem.selling_plan=Number(sellingPlan.value);
  var items=[mainItem];
  var giftToggle=form.querySelector('[data-mp-gift-toggle]');
  var giftWrapId=parseInt(root.getAttribute('data-mp-gift-wrap-variant-id'),10)||0;
  if(giftToggle&&giftToggle.checked&&giftWrapId){
    items.push({id:giftWrapId,quantity:quantity,properties:{'_Gift for':root.getAttribute('data-product-title')||'Gift card'}});
  }
  setButton(atc,false,'Adding gift card…');
  setButton(sticky,false,'Adding gift card…');
  var shopRoot=window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root?window.Shopify.routes.root:'/';
  fetch(shopRoot+'cart/add.js',{
    method:'POST',
    credentials:'same-origin',
    headers:{'Content-Type':'application/json','Accept':'application/json'},
    body:JSON.stringify({items:items})
  }).then(function(response){
    if(!response.ok)return response.json().catch(function(){return {};}).then(function(data){throw new Error(data.description||data.message||'Cart add failed');});
    return response.json();
  }).then(function(){window.location.assign(shopRoot+'cart');})
    .catch(function(error){showSubmitError(error&&error.message);});
}

form.addEventListener('submit',function(event){
  event.preventDefault();
  event.stopImmediatePropagation();
  addSelectedToCart();
},true);

document.addEventListener('click',function(event){
  var target=event.target.closest&&event.target.closest('[data-mp-sticky-atc]');
  if(!target||!root.contains(target))return;
  event.preventDefault();
  event.stopImmediatePropagation();
  addSelectedToCart();
},true);

form.addEventListener('change',function(event){
  if(event.target&&event.target.matches('[data-mp-gift-toggle]'))window.setTimeout(function(){if(selected)renderSelected();else renderEmpty();},0);
});

updateKeyFact();
var initial=amountData.find(function(item){return !!item.selected;})||null;
if(initial){selected=initial;renderSelected();}else renderEmpty();
window.addEventListener('DOMContentLoaded',function(){updateKeyFact();if(selected)renderSelected();else renderEmpty();},{once:true});
})();
